import styled from 'styled-components/macro';

import { deviceMax, deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { Images } from 'assets/images';

export const HotOffersBlock = styled.div`
  width: 100%;
  margin-top: -170px;
  @media ${deviceMin.mobileS} {
    margin-top: 0px;
  }

  @media ${deviceMin.tablet} {
    margin-top: 0px;
  }

  @media ${deviceMin.laptopL} {
    margin-top: -170px;
  }

  @media ${deviceMin.desktop} {
    margin-top: -170px;
  }

  .desc {
    margin-bottom: 40px;
    ${FONTS.font24}
    ${FONT_FAMILY.FontBold}
    color: ${COLORS.darkGray};

    @media ${deviceMax.tablet} {
      ${FONTS.font16}
      text-align: center;
    }

    @media ${deviceMax.mobileL} {
      padding: 0;
      margin-bottom: 11px;
      text-align: center;
      ${FONTS.font24}
    }
  }
  .hotTitleWrapper {
    ${FLEX_CONTAINER.FlexRow}

    @media ${deviceMin.laptopL} {
      margin-right: 51px;
    }

    @media ${deviceMin.desktop} {
      margin-right: 75px;
    }

    img {
      @media ${deviceMin.mobileS} {
        width: 62px;
        height: 57px;
      }

      @media ${deviceMin.mobileL} {
        width: 62px;
        height: 57px;
      }

      @media ${deviceMin.tablet} {
        width: 98px;
        height: 90px;
      }

      @media ${deviceMin.laptopL} {
        width: 122px;
        height: 112px;
      }

      @media ${deviceMin.desktop} {
        width: 173px;
        height: 160px;
      }
    }
  }

  .title {
    ${FONT_FAMILY.FontBold}
    ${FONTS.font24}
    color: ${COLORS.blueBlack};
    text-align: center;
    margin-left: 32px;

    @media ${deviceMin.mobileS} {
      margin-left: 20px;
      ${FONTS.font15}
    }
    @media ${deviceMin.tablet} {
      margin-left: 25px;
      ${FONTS.font16}
    }
    @media ${deviceMin.laptopL} {
      margin-left: 23px;
      ${FONTS.font24}
      width: 160px;
    }
    @media ${deviceMin.desktop} {
      margin-left: 32px;
      ${FONTS.font28}
      width: 211px;
    }
    span {
      color: ${COLORS.yellow};
    }
  }

  .sliderInfo {
    ${FLEX_CONTAINER.FlexRow}
    margin-top: -70px;

    @media ${deviceMin.mobileS} {
      margin-top: 40px;
    }
    //@media ${deviceMin.mobileL} {
    //  margin-top: 60px;
    //}
    @media ${deviceMin.tablet} {
      margin-top: 42px;
    }
    @media ${deviceMin.laptopL} {
      margin-top: 0px;
    }
    @media ${deviceMin.desktop} {
      margin-top: -70px;
    }
    .slick-next:before,
    .slick-prev.slick-disabled:before,
    .slick-next.slick-disabled:before {
      display: none;
    }
  }
  .info-wrapper {
    ${FLEX_CONTAINER.FlexStartColumn}
    padding: 100px 0 0 71px;

    @media ${deviceMin.mobileS} {
      display: none;
    }

    @media ${deviceMin.tablet} {
      display: block;
      padding: 0 0 0 46px;
      margin-top: -20px;
      width: 100%;
    }

    @media ${deviceMin.laptopL} {
      padding: 70px 0 0 60px;
      margin-top: 0;
      width: 50%;
    }

    @media ${deviceMin.desktop} {
      padding: 120px 0 0 71px;
      margin-top: 0;
      width: 65%;
    }

    .infoTitle {
      font-style: normal;
      ${FONT_FAMILY.FontMedium}
      ${FONTS.font24}
      margin-bottom: 30px;

      @media ${deviceMin.tablet} {
        ${FONTS.font16}
        margin-bottom: 14px;
      }

      @media ${deviceMin.laptopL} {
        ${FONTS.font20}
        margin-bottom: 24px;
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font24}
        margin-bottom: 30px;
      }
    }

    .infoDesc {
      ${FONTS.font16}
    }

    img {
      margin-bottom: 30px;
      @media ${deviceMin.mobileS} {
      }

      @media ${deviceMin.mobileL} {
      }
      @media ${deviceMin.tablet} {
        margin-bottom: 14px;
      }
      @media ${deviceMin.laptopL} {
        margin-bottom: 24px;
      }
      @media ${deviceMin.desktop} {
        margin-bottom: 30px;
      }
    }
    span {
      ${FONTS.font16}
      margin-top: 30px;
      @media ${deviceMin.mobileS} {
      }

      @media ${deviceMin.mobileL} {
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font14}
        margin-top: 14px;
      }
      @media ${deviceMin.laptopL} {
        ${FONTS.font16}
        margin-top: 24px;
      }
      @media ${deviceMin.desktop} {
        ${FONTS.font16}
        margin-top: 30px;
      }
    }
  }
`;

export const HotOffersCardWrapper = styled.div`
  @media ${deviceMax.mobileL} {
    width: 240px !important;
    margin: 0 8.5px;
  }
`;

export const CarouselArrow = styled.button`
  ${FLEX_CONTAINER.FlexCenterRow}
  height: 46.5px;
  width: 28.71px;
  right: ${({ right }) => right && '-28px'};
  left: ${({ left }) => left && '-28px'};
  transform: translateY(-50%);
  top: 50%;

  & > svg {
    width: inherit;
    height: inherit;
    transform: ${({ left }) => left && 'rotate(180deg)'};
  }

  &:hover {
    & > svg {
      path {
        fill: #514f4f;
      }
    }
  }

  ::before {
    content: none;
  }

  @media ${deviceMax.laptopM} {
    width: 19.14px;
    height: 31px;
    right: ${({ right }) => right && '-61px'};
    left: ${({ left }) => left && '-61px'};
  }
`;

export const ContentContainer = styled.div`
  background-image: url(${Images.hotSeconc});
  background-size: cover;
  background-repeat: no-repeat;
  //margin-top: -300px;
  margin-bottom: 50px;

  margin-top: 50px;
  @media ${deviceMin.mobileS} {
    //margin-top: 550px;
    background-size: 100% 346px;
    height: 346px;
  }
  @media ${deviceMin.tablet} {
    //margin-top: 328px;
    background-size: 100% 630px;
    height: 630px;
  }
  @media ${deviceMin.laptopL} {
    margin-top: 0;
    background-size: 100% 770px;
    height: 770px;
  }
  @media ${deviceMin.desktop} {
    background-size: 100% 961px;
    height: 960px;
  }
  @media ${deviceMax.tablet} {
    width: 100%;
  }

  @media ${deviceMax.mobileL} {
    width: 100%;
  }
`;
